import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';

export const PhasedBuildoutSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const text = report.testFitAnalysis?.phaseLayout;
  return (
    <SectionShell label={label} hasData={!!text}>
      {text && <p>{text}</p>}
    </SectionShell>
  );
};
